module.exports = __webpack_public_path__ + "static/mike-0104d3ac7029433997a1872345ac8df8.jpg";